import { Button } from "@repo/ui/components/ui/button";
import { Card } from "@repo/ui/components/ui/card";
import { useRouter } from "@repo/ui/hooks/use-router";
import { CheckCircle, ArrowRight } from "lucide-react";
import { useEffect, useState } from "react";

export default function SignupSuccessPage() {
  const router = useRouter();
  const [countdown, setCountdown] = useState(5);

  useEffect(() => {
    // Countdown timer
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          router.push('/auth/login?message=account_created');
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [router]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-emerald-50 via-white to-emerald-50 p-4">
      <Card className="max-w-2xl w-full p-8 shadow-xl">
        <div className="text-center space-y-6">
          {/* Success Icon */}
          <div className="flex justify-center">
            <div className="relative">
              <div className="absolute inset-0 bg-emerald-500 rounded-full opacity-20 animate-ping"></div>
              <div className="relative bg-emerald-500 rounded-full p-6">
                <CheckCircle className="h-16 w-16 text-white" />
              </div>
            </div>
          </div>

          {/* Title */}
          <div className="space-y-2">
            <h1 className="text-3xl font-bold text-gray-900">
              Paiement réussi ! 🎉
            </h1>
            <p className="text-lg text-gray-600">
              Votre compte Dendromap a été créé avec succès
            </p>
          </div>

          {/* Info Box */}
          <div className="bg-emerald-50 border border-emerald-200 rounded-lg p-6 space-y-3 text-left">
            <h3 className="font-semibold text-gray-900 flex items-center gap-2">
              <CheckCircle className="h-5 w-5 text-emerald-600" />
              Prochaines étapes
            </h3>
            <ul className="space-y-2 text-sm text-gray-700">
              <li className="flex items-start gap-2">
                <span className="text-emerald-600 mt-1">✓</span>
                <span>Un email de bienvenue vous a été envoyé avec vos informations de connexion</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-emerald-600 mt-1">✓</span>
                <span>Vérifiez votre boîte mail pour activer votre compte (email de confirmation)</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-emerald-600 mt-1">✓</span>
                <span>Une fois vérifié, vous pourrez accéder à toutes les fonctionnalités de votre plan</span>
              </li>
            </ul>
          </div>

          {/* Actions */}
          <div className="space-y-3 pt-4">
            <Button
              onClick={() => router.push('/auth/login?message=account_created')}
              className="w-full bg-emerald-600 hover:bg-emerald-700 text-white h-12 text-base font-semibold"
            >
              Se connecter maintenant
              <ArrowRight className="ml-2 h-5 w-5" />
            </Button>

            <p className="text-sm text-gray-500">
              Redirection automatique dans <span className="font-bold text-emerald-600">{countdown}</span> secondes...
            </p>
          </div>

          {/* Support Link */}
          <div className="pt-6 border-t border-gray-200">
            <p className="text-sm text-gray-600">
              Besoin d'aide ?{' '}
              <a href="/home#contact" className="text-emerald-600 hover:text-emerald-700 font-medium underline">
                Contactez notre support
              </a>
            </p>
          </div>
        </div>
      </Card>
    </div>
  );
}
